<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <excuse-type-create-or-update v-model="type" :errors="errors"></excuse-type-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="excuse-type"
                    :buttons="buttons"
                    :items-provider="provider"
                    pagination="server">
        </v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
import ExcuseTypeCreateOrUpdate from './components/ExcuseTypeCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        ExcuseTypeCreateOrUpdate
    },
    data(){
        return{
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            fields:[
                {name:"Tip",key:"Name",thClass:'w-80'},
                {name:"Çalışma Gün Türü",key:"EmployeeWorkingType.Name"},
                {name:"Renk",key:"Color",thClass:'w-10',component:true,componentOptions:{name:"color-preview/ColorPreview"}},
                {name:"Simge",key:"Icon",thClass:'w-10',component:true,componentOptions:{name:"icon-preview/IconPreview"}},
                {name:"Dosya Gerekli",key:"IsDocumentRequired"},
            ],
            loading:false,
            errors:{},
            editing:false,
            type:{
                Id:null,
                Color:null,
                Icon:null,
                IsDocumentRequired:false,
                Name:null,
                EmployeeWorkingTypeId:null
            },
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.type.Id = null
            this.type.Color = null
            this.type.Icon = null
            this.type.IsDocumentRequired = false
            this.type.PrimaryExcuse = false
            this.type.Name = null
            this.type.EmployeeWorkingTypeId = null
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.type.Id = item.Id
            this.type.Color = item.Color
            this.type.Icon = item.Icon
            this.type.IsDocumentRequired = item.IsDocumentRequired
            this.type.PrimaryExcuse = item.PrimaryExcuse
            this.type.Name = item.Name
            this.type.EmployeeWorkingTypeId = item.EmployeeWorkingType?.Id || null
            this.$showModal('create-or-update')
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return EmployeeOperationsApi.ExcuseType.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.ExcuseType.CreateOrUpdate(this.type).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli izin türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.ExcuseType.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>